import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import BookSlot from './pages/BookSlot';
import TestSuccess from './pages/TestSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentSuccess from './pages/TestSuccess';
import BookCounseling from './pages/BookCounseling';

// Auth guard component
const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('user') !== null;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/book-slot/:programId" 
          element={
            <PrivateRoute>
              <BookSlot />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/test-success/:bookingId" 
          element={
            <PrivateRoute>
              <TestSuccess />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/book-counseling/:testBookingId" 
          element={
            <PrivateRoute>
              <BookCounseling />
            </PrivateRoute>
          } 
        />
        {/* Payment routes - accessible without authentication */}
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
      </Routes>
    </Router>
  );
}

export default App;
